
import { Component, Inject, InjectReactive, Vue } from "vue-property-decorator";
import { API_ENDPOINT_SYMBOL, USER_PROFILE_SYMBOL } from "../../constants";

@Component({})
export default class AuthBtn extends Vue {
  @Inject(API_ENDPOINT_SYMBOL) public apiEndPoint;
  public authLoading = false;
}
